// extracted by mini-css-extract-plugin
export default {"content":"styles_content__jWNpi","layout":"styles_layout__VzS3X"};